import {
  OpcClient,
  OpcClientCreateRequest,
  OpcClientUpdateRequest,
} from '../../types/app/opcClient.types';
import { api } from '../core/api';

export const getOpcClientList = () =>
  api.get<OpcClient[]>('OpcClient/GetList').then((res) => res.data);

export const getOpcClient = (id: number) =>
  api.get<OpcClient>(`OpcClient/GetItem/?id=${id}`).then((res) => res.data);

export const browse = (endpoint: string) =>
  api.get(`OpcClient/Browse?endpoint=${endpoint}`).then((res) => res.data);

export const updateOpcClient = (data: OpcClientUpdateRequest) =>
  api.put(`OpcClient/UpdateItem`, data).then((res) => res.data);

export const createOpcClient = (data: OpcClientCreateRequest) =>
  api.post(`OpcClient/CreateItem`, data).then((res) => res.data);

export const deleteOpcClient = (id: number) =>
  api.delete<OpcClient>(`OpcClient/DeleteItem/?id=${id}`).then();
